import * as s from "./mockup-imac.module.less";
import React from "react";
import iMacImage from "../../../media/mockups/imac.png"
import {GatsbyImage as Img, getImage} from "gatsby-plugin-image";

const MockupIMac = ({
	screenShot,
	companyName
}) => {
	return (
		<div className={s.mockup}>
			<img
				src={iMacImage}
				alt={`${companyName} media`}
				className={s.mockImage}
			/>
			<div
				className={s.mediaElement}
			>
				<Img
					image={getImage(screenShot)}
					alt={`${companyName} media`}
				/>
			</div>
		</div>
	)
}
export default MockupIMac;
